<template>
  <div class="carga-archivos">
    <div>
      <Titulo titulo="Carga de archivos" />
    </div>
    <b-row class="justify-content-center align-items-center">
      <b-col cols="12" md="10">
        <div class="mt-3 text-right">
          <img
            v-if="loading"
            class="loading"
            src="@/assets/images/loader.gif"
            alt
          />
          <!--b-button type="button" @click="limpiarInputReset" variant="outline-primary" :disabled="loading" class="ml-1">Limpiar</b-button-->
        </div>
        <br>
        <div class="mx-auto" v-if="!loading">
          <div class="text-justify">
            <h4 class="color-secundary mb-4" v-text="'Certificación'"></h4>
          </div>
          <hr>
          <form @submit.prevent="enviarCertificacion()">
            <div class="form-group row">
              <div class="col-lg-12 col-md-12">
                <b-form-file
                  ref="archivo_certificacion"
                  required
                  size="md"
                  placeholder="Selecione un archivo"
                  browse-text="Anexar"
                  drop-placeholder="Suelte los archivos aqui...."
                  :disabled="dataLengthCertificacion == 0 || loading"
                  class="mt-2"
                  :accept="tipo_archivo ? tipo_archivo : '.pdf'"
                  :multiple="multiple ? multiple : false"
                >
                  <!-- style="padding-right: 80px;" -->
                  <template slot="file-name" slot-scope="{ names }">
                    <b-badge v-if="names.length > 0" variant="dark" class="ml-1"
                      >{{ names[0] }} | {{ names.length }} Archivo(s)
                      seleccionado(s)</b-badge
                    >
                  </template>
                </b-form-file>
              </div>
              <div class="col-lg-12 col-md-12">
                <select class="form-control" id="datos_certificacion" :disabled="loading" v-model="cargue_certificacion" required>
                  <option :value="null" disabled>Seleccione un cargue</option>
                  <option v-for="pagos in dataCertificacion" :key="pagos.archivo" :value="pagos.archivo">
                    {{ pagos.archivo }}
                  </option>
                </select>
              <div class="mt-3 text-right">
                <b-button type="submit" class="ml-1 button-carga" :disabled="dataLengthCertificacion == 0 || loading">Enviar</b-button>
              </div>
              </div>
            </div>
          </form>
        </div>
        <div class="mx-auto" v-if="!loading">
          <table-component
            :data="dataCertificacion"
            pagination
            @click-event="clickEvent"
            :perPage="perPage"
            :dataLength="dataLengthCertificacion"
          >
            <table-column
              slot="label"
              :label="'Nit'"
              v-bind:value="'nit'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Convenio'"
              v-bind:value="'convenio'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Producto'"
              v-bind:value="'producto'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Archivo'"
              v-bind:value="'archivo'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Fecha cargue'"
              v-bind:value="'fecha_cargue'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Total registros'"
              v-bind:value="'total_registros'"
              :customClass="'text-center'"
            ></table-column>
          </table-component>
        </div>
      </b-col>
      <!-- Panel Derecho -->
    </b-row>
  </div>
</template>
<script>
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "Certificacion",
  data: () => {
    return {
      pagination: false,
      files: new FormData(),
      tipo_archivo: "",
      multiple: true,
      perPage: 3,
      dataCertificacion: [],
      dataLengthCertificacion: 0,
      end_consulta_certificacion: false,
      cargue_certificacion: null,
      envio_certificacion: false,
    };
  },
  computed: {
    loading(){
      return this.end_consulta_certificacion == true && this.envio_certificacion == false ? false: true;
    },
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  methods: {
    async clickEvent(element, slug) {
      console.log(element, slug);
      if ((slug = "paginacion")) {
        this.getPendientes(element.page);
      }
    },
    async getPendientesCertificacion(page, paginar = "false") {
      this.end_consulta_certificacion = false;
      try {
        let request = await this.$store.state.api.get("/informes/cargues_certificacion", {
          params: {
            paginar,
            row: this.perPage,
            page,
          },
        });

        this.dataCertificacion = request.data.datos;
        this.dataLengthCertificacion = request.data.paginacion.total;
        this.end_consulta_certificacion = true;
      } catch (err) {
        this.end_consulta_certificacion = true;
        console.log(err);
        this.$toasted.show(
          "Ocurrió un error intentando consultar los registros pendientes para numero de cesion",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }
    },
    restablecerCertificacion(){
      this.cargue_certificacion = null;
      this.$refs["archivo_certificacion"].$refs.input.files.reset();
    },
    async enviarCertificacion(){
      this.envio_certificacion = true;
      let data_file = new FormData();
      const archivos_certificacion = this.$refs["archivo_certificacion"].$refs.input.files;
      data_file.append("archivo", this.cargue_certificacion);
      for (let i = 0; i < archivos_certificacion.length; i++) {
        data_file.append("certificaciones[]", archivos_certificacion[i]);
      }

      try{
        let data = await this.$store.state.api.post(
            "/pagos/almacenar_certificacion",
            data_file,
        );

        this.$toasted.show(
          "Se han guardado los archivos correctamente",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
        this.envio_certificacion = false;
      }catch(err){
        this.envio_certificacion = false;
        this.$toasted.show(
          "Ocurrió un error al guardar los archivos",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }

      // this.restablecerCertificacion();
      this.getPendientesCertificacion(1);
    },
  },
  mounted() {
    console.log('Certificacion');
    this.getPendientesCertificacion(1);
  },
};
</script>
<style>
.card-body {
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.4s ease;
}

.card-body:hover {
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.custom-list-group {
  display: flex;
  width: 600px;
}

.custom-list-item {
  flex: 1;
}
</style>